var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.475 10.7073L14.9092 12.3991V32.0028L11.475 36.5753L8.05303 37.7751L1.39008 32.8619L0 28.1138L11.475 10.7073Z",
    fill: "#D96D16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.525 10.7073L57.0908 12.3991V32.0028L60.525 36.5753L63.947 37.7751L70.6099 32.8619L72 28.1138L60.525 10.7073Z",
    fill: "#D96D16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.525 0V36.5752L60.1177 41.502L50.5751 48.7277L44.8355 48.4552L42.6381 51.1862H37.9L36 48.4552L24.1699 30.2645L36 0H60.525Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 0V48.4552L34.2244 51.1862H29.2889L27.1646 48.4552L22.3095 51.1862L11.1302 42.7215L11.4751 36.5752V0H36.0001Z",
    fill: "#F3F3F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0477 10.0182L36.0002 19.8549L34.5491 17.8791L36.0002 14.2074L44.2422 6.86816L47.0477 10.0182Z",
    fill: "#4E4743"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 14.2075V19.855L32.6391 22.8475L24.9596 16.075L27.7496 12.9109L32.6265 17.2112L36.0001 14.2075Z",
    fill: "#4E4743"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9262 27.6003V31.8191H36.0001L33.4718 29.7097L36.0001 27.6003H49.9262Z",
    fill: "#D7D7E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.074 27.6003H36.0001V31.8191H22.074V27.6003Z",
    fill: "#D7D7E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9262 37.3696V41.5884H36.0001L33.4718 39.3062L36.0001 37.3696H49.9262Z",
    fill: "#D7D7E6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.074 37.3696H36.0001V41.5884H22.074V37.3696Z",
    fill: "#D7D7E6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 72H35.9999H36H72V28.1138L60.525 36.5752L44.8354 48.4552H36H35.9999H27.1645L11.475 36.5752L0 28.1138V72Z",
    fill: "#FF8F34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileUploaded);
export default __webpack_public_path__ + "static/media/icon-file-uploaded.066c60258f280dc54885b0824b7b3ec8.svg";
export { ForwardRef as ReactComponent };